import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./components/pages/index";
import DdoubleCam from "./components/pages/DdoubleCam";
import HappyNow from "./components/pages/HappyNow";
import Advent from "./components/pages/AdventCal";
import AdventChild from "./components/pages/advent_enfants";
import Contact from "./components/pages/contact";
import Navbar from './components/Navbar';
function App() {
  return (
    <Router>
      <Navbar />
      <main className="content-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/DdoubleCam" element={<DdoubleCam />} />
          <Route path="/HappyNow" element={<HappyNow />} />
          <Route path="/Advent" element={<Advent />} />
          <Route path="/advent/invite" element={<Advent />} />
          <Route path="/Advent/childpolicy" element={<AdventChild />} />

          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
